import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import Buefy from 'buefy';
import axios from './plugins/axios';
import firebase from './plugins/firebase';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// import vueScrollto from 'vue-scrollto';

Vue.use(axios);
Vue.use(firebase);
// Vue.use(vueScrollto);

router.beforeEach(async ( to: any, from: any, next: any ) => {
  const thisStore =  store;
  const path = to.path;
  if (thisStore.state.signedIn || path === '/' || path === '/signin') {
    next();
  } else {
    next('/');
  }
});



Vue.use(Buefy);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
